import commonStore from '@store/commonStore'

export function usePendingTxns() {
  const pendingTxns = commonStore((store) => store.pendingTxns)
  const setPendingTxns = commonStore((store) => store.setPendingTxns)
  return [pendingTxns, setPendingTxns] as const
}
